import { UserIdentity } from './../identity/user-identity';
import { Logger, LoggerFactory } from './../logger.service';
import { IMtr } from './mtr.interface';
import { Site } from '../site-context.service';

export class MtrService implements IMtr {
  private readonly logger: Logger;
  private mtr: any;

  constructor(loggerFactory: LoggerFactory) {
    this.logger = loggerFactory.get('MtrService');
    this.getInstance(function () {});
  }
  public log(path: string, title: string, type: string) {
    this.getInstance(function (mtr) {
      if (!mtr) {
        return;
      }
      mtr.log(path, title, type);
    });
  }
  public goal(name: string, revenue?: number, callback?: any) {
    this.getInstance(function (mtr) {
      if (!mtr) {
        return;
      }
      mtr.goal(name, revenue, callback);
    });
  }
  public event(name: string) {
    this.getInstance(function (mtr) {
      if (!mtr) {
        return;
      }
      mtr.event(name);
    });
  }
  public setIdentity(userIdentity: UserIdentity, currentSite: Site) {
    const custom = (<any>window).mtr_custom || {};
    // Check if it's a known user
    if (userIdentity) {
      // Get data if there already is any set from somewhere else, otherwise create new object
      const customSession = custom.session || {};
      if (userIdentity.email) {
        customSession.email = userIdentity.email;
      }
      // Check if user has a site
      if (currentSite) {
        customSession.organization = currentSite.name;
      }
      custom.session = customSession;
    }
    // Update on window so tracker get's it
    (<any>window).mtr_custom = custom;
  }
  public setCustomData(property: string, data: string) {
    const custom = (<any>window).mtr_custom || {};
    // Get data if there already is any set from somewhere else, otherwise create new object
    const customSession = custom.session || {};
    customSession[property] = data;
    custom.session = customSession;
    // Update on window so tracker get's it
    (<any>window).mtr_custom = custom;
  }

  private getInstance(callback: any, attempt: number = 1) {
    const maxAttempts = 5;
    if (attempt > maxAttempts) {
      this.logger.debug('Failed to initiate tracker (mtr)');
      return;
    }
    if (this.mtr) {
      callback(this.mtr);
      return;
    }
    const instance = (<any>window).mtr;
    if (instance) {
      this.mtr = instance;
      callback(instance);
      return;
    }
    setTimeout(() => {
      this.logger.debug(`"mtr" is not defined, trying again. Attempt: ${attempt}`);
      this.getInstance(callback, attempt + 1);
    }, 400);
  }
}
